import { IntegrationElement } from '../Components'
import JiraLogo from 'Assets/images/jira.svg'

export const QUICKBOOKS_INTEGRATIONS = {
  id: 'quickbooks',
  logo: JiraLogo,
  title: 'Quickbooks',
  description: 'Connect your QuickBooks account to generate and track your invoices.'
}

const QuikbooksIntegration = ({ project, refreshProjectInfo }) => {
  return (
    <IntegrationElement
      logo={QUICKBOOKS_INTEGRATIONS.logo}
      title={QUICKBOOKS_INTEGRATIONS.title}
      description={QUICKBOOKS_INTEGRATIONS.description}
    />
  )
}

export default QuikbooksIntegration
